export const getIsCarregandoRelatorioPABSDetalhado =
  (state) => state.relatoriosPABS.isCarregandoRelatorioPABSDetalhado

export const getIsCarregandoRelatorioPABSResumido =
  (state) => state.relatoriosPABS.isCarregandoRelatorioPABSResumido

export const getIsCarregandoRelatorioPABSGeral =
  (state) => state.relatoriosPABS.isCarregandoRelatorioPABSGeral
